import { render, staticRenderFns } from "./AllRestoreTasks.vue?vue&type=template&id=9975fa34&"
import script from "./AllRestoreTasks.vue?vue&type=script&lang=ts&"
export * from "./AllRestoreTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports